@if (!breakpointService.isMobile()) {
    <app-header-banner
            [localAsset]="true"
            bannerDescription="My Wishlist - booking wizard"
            bannerImage="about_banner.jpg"
            [disableBackToPlan]="false"
    ></app-header-banner>
    @if (tripsCollection() === null) {
        <div class="f-row f-center f-v-center loading-block">
            We are preparing your wishlist ...
        </div>
    } @else if (tripsCollection()?.length) {
        <div class="f-row f-between f-v-center content-header">
            <div class="f-row f-v-center">
                <h3 class="content-header--title">
                    Trip Services
                    <span>
                        {{ selectedTrip()?.name }}
                    </span>
                </h3>
            </div>
            <button class="f-row f-between f-v-center select-trip" (input)="setCurrentTrip($event)"
                    [matMenuTriggerFor]="menu">
                <span>{{ selectedTrip().name }} </span>
                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="wishlist-select-country-menu">
                @for (trip of tripsCollection(); track trip; let i = $index) {
                    <button mat-menu-item class="select-trip--button" (click)="selectedTrip.set(trip)">{{ trip.name }}
                    </button>
                }
            </mat-menu>
        </div>

        <section>
            <div class="info">
                <div class="trip-container">
                    <div class="f-row trip-container-header">
                        <div class="col"></div>
                        <div class="col-4">
                            <div class="f-row f-v-center">
                                <div class="col-2 text-center">
                                    <div class="provider--icon">
                                        <img src="assets/svg/ic-hotels-b.svg" alt="hotels-icon">
                                    </div>
                                    <div class="provider--title">Hotels</div>
                                    <div class="provider--logo">
                                        <img [src]="partnersLogosUrl[0] | safeUrl" alt="">
                                    </div>
                                </div>
                                <div class="col text-center">
                                    <div class="provider--icon">
                                        <img src="assets/svg/ic-activities.svg" alt="">
                                    </div>
                                    <div class="provider--title">Activities</div>
                                    <div class="provider--logo">
                                        <img [src]="partnersLogosUrl[1] | safeUrl" alt="">
                                    </div>
                                </div>
                                <div class="col text-center">
                                    <div class="provider--icon">
                                        <img src="assets/svg/ic-event.svg" alt="">
                                    </div>
                                    <div class="provider--title">Events</div>
                                    <div class="provider--logo">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dash-container">
                        @for (city of selectedTrip()?.preview; track city; let i = $index) {
                            <div class="f-row mb-4">
                                <div class="col">
                                    <div class="f-row f-v-center pr-2rem">
                                        <div class="trip-container--index" [style.--pin-color]="PIN_COLORS[i]">
                                            <span class="trip-container--index--text"> {{ i + 1 }}</span>
                                        </div>
                                        <div class="box-bg pin-box">
                                            <div class="d-flex f-end pin-box--duration">{{ city.days }}</div>
                                            <div class="pin-box--label">{{ city.cityName }}</div>
                                            <div class="pin-box--desc">{{ city.regionName }}, {{ city.countryName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4 box-bg row-bg">
                                    @if (city.expanded) {
                                        <div class="f-row expanded-panel text-center">
                                            <div class="col-2">
                                                @if (city.favorites | getFavoritesByProvider: 'booking.com'; as favorites) {
                                                    @if (favorites.length) {
                                                        @for (favorite of favorites; track favorite) {
                                                            <app-booking-hotel-card
                                                                    [hotelData]="favorite.additionalData"
                                                                    [cityId]="city.place_id"
                                                                    [cityName]="''"
                                                                    [countryName]="''"
                                                                    (onUnFavourite)="removeFavoriteFromList(favorite, city)"
                                                            ></app-booking-hotel-card>
                                                        }
                                                    } @else {
                                                        <button class="favorite-box--button button-opacity"
                                                                (click)="browseTripPage(placeProvider.BOOKING, i)">
                                                            Browse
                                                        </button>
                                                    }
                                                }
                                            </div>
                                            <div class="col">
                                                @if (city.favorites | getFavoritesByProvider: 'viator'; as favorites) {
                                                    @if (favorites.length) {
                                                        @for (favorite of favorites; track favorite) {
                                                            <div class="viator-group__list--item">
                                                                <app-viator-group></app-viator-group>
                                                                <a class="item-href" [attr.href]="favorite.additionalData.url"
                                                                   target="_blank">
                                                                    <div class="item-image"
                                                                         [style.background-image]="'url(' + favorite.additionalData.image[0]?.url + ')'">
                                                                    </div>
                                                                    <p class="item-text">{{ favorite.additionalData.name }}</p>

                                                                    <div class="item-actions">
                                                                        <div class="item-actions__row">
                                                                            <button class="btn-hurt" [class.active]="true"
                                                                                    (click)="$event.preventDefault(); deleteViatorFavourite(favorite, city)">
                                                                                <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
                                                                            </button>
                                                                            <button class="btn-default btn-buy">Book</button>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        }
                                                    } @else {
                                                        <button class="favorite-box--button button-opacity"
                                                                (click)="browseTripPage(placeProvider.VIATOR, i)">
                                                            Browse
                                                        </button>
                                                    }
                                                }
                                            </div>
                                            <div class="col">
                                                @if (city.favorites | getFavoritesByProvider: 'occasion_genius'; as favorites) {
                                                    @if (favorites.length) {
                                                        @for (favorite of favorites; track favorite) {
                                                            <app-occasion-genius-card
                                                                    [event]="favorite.additionalData"
                                                                    [placeId]="city.place_id"
                                                                    [cityName]="''"
                                                                    [countryName]="''"
                                                                    (onUnFavourite)="removeFavoriteFromList(favorite, city)"
                                                            ></app-occasion-genius-card>
                                                        }
                                                    } @else {
                                                        <button class="favorite-box--button button-opacity"
                                                                (click)="browseTripPage(placeProvider.GENIUS, i)">
                                                            Browse
                                                        </button>
                                                    }
                                                }
                                            </div>
                                            <button mat-icon-button (click)="city.expanded = !city.expanded">
                                                <mat-icon [svgIcon]="eSvgIcons.MINUS"></mat-icon>
                                            </button>
                                        </div>
                                    } @else {
                                        <div class="f-row f-v-center">
                                            <div class="col-2 f-row f-center">
                                                <div class="favorite-box">
                                                    @if ((city.favorites | getFavoritesByProvider: placeProvider.BOOKING).length; as favorites) {
                                                        <button class="favorite-box--button"
                                                                (click)="city.expanded = !city.expanded">View
                                                        </button>
                                                        <div class="favorite-box-absolute">
                                                            <img src="assets/images/heart-icon.png" alt=""
                                                                 class="favorite-box--icon">
                                                            <span class="favorite-box--amount">{{ favorites }}</span>
                                                        </div>
                                                    } @else {
                                                        <button class="favorite-box--button button-opacity"
                                                                (click)="browseTripPage(placeProvider.BOOKING, i)">
                                                            Browse
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                            <div class="col f-row f-center">
                                                <div class="favorite-box">
                                                    @if ((city.favorites | getFavoritesByProvider: placeProvider.VIATOR).length; as favorites) {
                                                        <button class="favorite-box--button"
                                                                (click)="city.expanded = !city.expanded">View
                                                        </button>
                                                        <div class="favorite-box-absolute">
                                                            <img src="assets/images/heart-icon.png" alt=""
                                                                 class="favorite-box--icon">
                                                            <span class="favorite-box--amount">{{ favorites }}</span>
                                                        </div>
                                                    } @else {
                                                        <button class="favorite-box--button button-opacity"
                                                                (click)="browseTripPage(placeProvider.VIATOR, i)">
                                                            Browse
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                            <div class="col f-row f-center">
                                                <div class="favorite-box">
                                                    @if ((city.favorites | getFavoritesByProvider: placeProvider.GENIUS).length; as favorites) {
                                                        <button class="favorite-box--button"
                                                                (click)="city.expanded = !city.expanded">
                                                            View
                                                        </button>
                                                        <div class="favorite-box-absolute">
                                                            <img src="assets/images/heart-icon.png" alt=""
                                                                 class="favorite-box--icon">
                                                            <span class="favorite-box--amount">{{ favorites }}</span>
                                                        </div>
                                                    } @else {
                                                        <button class="favorite-box--button button-opacity"
                                                                (click)="browseTripPage(placeProvider.GENIUS, i)">
                                                            Browse
                                                        </button>
                                                    }
                                                </div>
                                            </div>

                                          @if (!!(city.favorites | getFavoritesByProvider: placeProvider.BOOKING)?.length || !!(city.favorites | getFavoritesByProvider: placeProvider.VIATOR)?.length || !!(city.favorites | getFavoritesByProvider: placeProvider.GENIUS)?.length) {
                                            <button mat-icon-button (click)="city.expanded = !city.expanded">
                                              <mat-icon [svgIcon]="eSvgIcons.ADD"></mat-icon>
                                            </button>
                                          } @else {
                                            <div style="width: 48px; height: 48px;"></div>
                                          }
                                        </div>
                                    }
                                </div>
                            </div>

                        }
                    </div>
                </div>
            </div>
        </section>
        <div class="f-row f-center f-v-center info-section">
            <div class="info-container">
                <h3 class="info-container--title">
                    {{ 'WISHLIST_PAGE.TITLE' | translate }}
                </h3>
                <p class="info-container--description cancellation">Free cancellation available</p>
                <p class="info-container--booking">
                    Use
                    <a href="https://www.booking.com/index.html?aid=7947415" target="_blank">this link</a> to book with
                    <img [src]="partnersLogosUrl[0] | safeUrl" alt="booking"><br>
                    <span>and get free perks via our app: </span><br>
                    Discover new sights and hidden gems while driving between destinations with our En-Route GPS based
                    app
                </p>
                <p class="info-container--description">
                    {{ 'WISHLIST_PAGE.CONTENT_1' | translate }}
                </p>
                <p class="info-container--description">
                    {{ 'WISHLIST_PAGE.CONTENT_2' | translate }}
                </p>
                <p class="info-container--description">
                    {{ 'WISHLIST_PAGE.CONTENT_3' | translate }}
                </p>
            </div>
            <div class="info-image">
                <figure>
                    <img [src]="contentBannerUrl | safeUrl" alt="content img">
                </figure>
            </div>
        </div>
    }
} @else {
    <div class="wish-list" [class.wish-list--no-padding]="mobilePreviewCityIndex === -1">
        @if (mobilePreviewCityIndex === -1) {
            <div class="wish-list__header">
                <button class="wish-list__selector" (input)="setCurrentTrip($event)" [matMenuTriggerFor]="menu">
                    <span class="wish-list__selector--name">{{ selectedTrip()?.name }}</span>
                    <span class="wish-list__selector--select">Select</span>
                </button>
                <mat-menu #menu="matMenu" class="wishlist-select-country-menu">
                    @for (trip of tripsCollection(); track trip; let i = $index) {
                        <button mat-menu-item class="select-trip--button"
                                (click)="selectedTrip.set(trip)">{{ trip?.name }}
                        </button>
                    }
                </mat-menu>
                <div class="wish-list__header--title">
                    <h1>Your Wishlist</h1>
                    <p>{{ selectedTrip()?.preview?.length }} services in your wishlist</p>
                </div>
            </div>
            <div class="wish-list__content">
                <div class="wish-list__list">
                    @if (isFetching()) {
                        @for (wish of [1, 2, 3]; track wish; let i = $index) {
                            <app-wish-preview-card-mobile
                                    [isFetching]="true"
                            ></app-wish-preview-card-mobile>
                        }
                    } @else {
                        @for (wish of selectedTrip()?.preview; track wish; let i = $index) {
                            <app-wish-preview-card-mobile
                                    [wish]="wish"
                                    (click)="selectMobilePreview(i)"
                            ></app-wish-preview-card-mobile>
                        }
                    }
                </div>
            </div>
        } @else {
            <div class="wish-list__header">
                <div class="wish-list__navigation">
                    <button class="wish-list__navigation--prev"
                            [disabled]="!selectedTrip()?.preview[mobilePreviewCityIndex - 1]"
                            (click)="selectMobilePreview(mobilePreviewCityIndex - 1)">
                        <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
                        <span>{{ selectedTrip()?.preview[mobilePreviewCityIndex - 1]?.cityName }}</span>
                    </button>

                    <div class="wish-list__navigation--info">
                        <div class="wish-list__navigation--title">
                            {{ selectedTrip()?.preview[mobilePreviewCityIndex].cityName }}
                        </div>
                        <div class="wish-list__navigation--count">
                            {{ selectedTrip()?.preview[mobilePreviewCityIndex].days }}
                        </div>
                    </div>

                    <button class="wish-list__navigation--next"
                            [disabled]="!selectedTrip()?.preview[mobilePreviewCityIndex + 1]"
                            (click)="selectMobilePreview(mobilePreviewCityIndex + 1)">
                        <span>{{ selectedTrip()?.preview[mobilePreviewCityIndex + 1]?.cityName }}</span>
                        <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT_1"></mat-icon>
                    </button>
                </div>
                <div class="mobile-tabs">
                    <button class="tab-button"
                            [class.active]="mobileCardCityPreviewIndex === 0"
                            (click)="selectCardCityPreview(0)">
                        @if ((selectedTrip()?.preview[mobilePreviewCityIndex].favorites | getFavoritesByProvider: 'booking.com').length; as count) {
                            <span class="tab-button__badge">{{ count }}</span>
                        }
                        <span class="tab-button__text">Hotels</span>
                    </button>
                    <button class="tab-button"
                            [class.active]="mobileCardCityPreviewIndex === 1"
                            (click)="selectCardCityPreview(1)">
                        @if ((selectedTrip()?.preview[mobilePreviewCityIndex].favorites | getFavoritesByProvider: 'viator').length; as count) {
                            <span class="tab-button__badge">{{ count }}</span>
                        }
                        <span class="tab-button__text">Activities</span>
                    </button>
                    <button class="tab-button"
                            [class.active]="mobileCardCityPreviewIndex === 2"
                            (click)="selectCardCityPreview(2)">
                        @if ((selectedTrip()?.preview[mobilePreviewCityIndex].favorites | getFavoritesByProvider: 'occasion_genius').length; as count) {
                            <span class="tab-button__badge">{{ count }}</span>
                        }
                        <span class="tab-button__text">Events</span>
                    </button>
                </div>
            </div>
            <div class="wish-list__content">
                <div class="wish-list__list">
                    @if (mobileCardCityPreviewIndex === 0) {
                        @if (selectedTrip()?.preview[mobilePreviewCityIndex].favorites | getFavoritesByProvider: 'booking.com'; as favorites) {
                            @if (favorites.length) {
                                <div class="wish-list__details">
                                    <div class="wish-list__details--text">
                                        <span><span class="bold">{{ favorites.length }}</span> favorite hotels by</span>
                                    </div>
                                    <div class="wish-list__details--image">
                                        <mat-icon [svgIcon]="eSvgIcons.BOOKING"></mat-icon>
                                    </div>
                                </div>
                                @for (favorite of favorites; track favorite) {
                                    <app-hotel-card-mobile
                                            [hotel]="favorite.additionalData"
                                            [isDefaultCard]="true"
                                    ></app-hotel-card-mobile>
                                }
                            } @else {
                                <div class="wish-list__empty">
                                    <div class="wish-list__empty--icon">
                                        <mat-icon [svgIcon]="eSvgIcons.EMPTY_WISH_LIST"></mat-icon>
                                    </div>
                                    <h3 class="wish-list__empty--title">
                                        Currently, you don't have any
                                        favorite attractions
                                    </h3>
                                    <p class="wish-list__empty--description">
                                        Browse and save your favorite attractions to revisit and book them later!
                                    </p>
                                    <button class="btn-default btn-blue btn-mobile"
                                            (click)="browseTripPage(placeProvider.BOOKING, mobileCardCityPreviewIndex)">
                                        Browse attractions
                                    </button>
                                </div>
                            }
                        }
                    }
                    @if (mobileCardCityPreviewIndex === 1) {
                        @if (selectedTrip()?.preview[mobilePreviewCityIndex].favorites | getFavoritesByProvider: 'viator'; as favorites) {
                            @if (favorites.length) {
                                <div class="wish-list__details">
                                    <div class="wish-list__details--text">
                                        <span><span
                                                class="bold">{{ favorites.length }}</span> favorite activities by</span>
                                    </div>
                                    <div class="wish-list__details--image">
                                        <mat-icon [svgIcon]="eSvgIcons.VIATOR"></mat-icon>
                                    </div>
                                </div>
                                @for (favorite of favorites; track favorite) {
                                    <app-viator-card-mobile
                                            [viator]="favorite.additionalData"
                                    ></app-viator-card-mobile>
                                }
                            } @else {
                                <div class="wish-list__empty">
                                    <div class="wish-list__empty--icon">
                                        <mat-icon [svgIcon]="eSvgIcons.EMPTY_WISH_LIST"></mat-icon>
                                    </div>
                                    <h3 class="wish-list__empty--title">
                                        Currently, you don't have any
                                        favorite attractions
                                    </h3>
                                    <p class="wish-list__empty--description">
                                        Browse and save your favorite attractions to revisit and book them later!
                                    </p>
                                    <button class="btn-default btn-blue btn-mobile"
                                            (click)="browseTripPage(placeProvider.VIATOR, mobileCardCityPreviewIndex)">
                                        Browse attractions
                                    </button>
                                </div>
                            }
                        }
                    }
                    @if (mobileCardCityPreviewIndex === 2) {
                        @if (selectedTrip()?.preview[mobilePreviewCityIndex].favorites | getFavoritesByProvider: 'occasion_genius'; as favorites) {
                            @if (favorites.length) {
                                <div class="wish-list__details">
                                    <div class="wish-list__details--text">
                                        <span><b>{{ favorites.length }}</b> favorite activities</span>
                                    </div>
                                </div>
                                @for (favorite of favorites; track favorite) {
                                    <app-occasion-genius-card-mobile
                                            [events]="[favorite.additionalData]"
                                    ></app-occasion-genius-card-mobile>
                                }
                            } @else {
                                <div class="wish-list__empty">
                                    <div class="wish-list__empty--icon">
                                        <mat-icon [svgIcon]="eSvgIcons.EMPTY_WISH_LIST"></mat-icon>
                                    </div>
                                    <h3 class="wish-list__empty--title">
                                        Currently, you don't have any
                                        favorite attractions
                                    </h3>
                                    <p class="wish-list__empty--description">
                                        Browse and save your favorite attractions to revisit and book them later!
                                    </p>
                                    <button class="btn-default btn-blue btn-mobile"
                                            (click)="browseTripPage(placeProvider.GENIUS, mobileCardCityPreviewIndex)">
                                        Browse attractions
                                    </button>
                                </div>
                            }
                        }
                    }
                </div>
            </div>
        }
    </div>

  <div class="user-account__back-wrapper">
    <button class="user-account__back-trip" (click)="backToTrip()">
      <mat-icon [svgIcon]="eSvgIcons.TRIP_WHITE"></mat-icon>
    </button>
  </div>
}
